import { injectable } from "tsyringe";
import { PosRevenueApiRepository } from "@/app/infrastructures/repositories/api/PosRevenueApiRepository";
import { TopCommodityResponse, TopCommodity } from "@/domain/entities/PosRevenue";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";

@injectable()
export class PosRevenuePresenter {
  private repository: PosRevenueApiRepository;

  constructor(repository: PosRevenueApiRepository) {
    this.repository = repository;
  }

  public async getTopCommodity(params: Record<string, any>): Promise<TopCommodityResponse> {
    try {
      const resp = await this.repository.getTopCommodity(params);
      const items: TopCommodity[] = Array.isArray(resp?.data?.data) ? resp.data.data : [];
      const lastSyncAt: string = resp?.data?.lastSyncAt ?? resp?.data?.last_sync_at ?? "";
      const cityCode: string = resp?.data?.cityCode ?? resp?.data?.city_code ?? "";
      return new TopCommodityResponse({ lastSyncAt, cityCode, data: items });
    } catch (err) {
      const errorEntities = parsingErrorResponse(err, "Gagal Mendapatkan Top Commodity");
      throw errorEntities;
    }
  }
}